// RunPage — German. The console's language; the record's own content stays French.
// 'not collected', 'Loading…', 'Saving…', 'refused', 'held', 'unheld' and the small words live
// in common.de.ts and are not repeated here.
//
// 'running' and the '{unheld} … {held} … {refused}' tally are deliberately ABSENT: another
// catalogue already declares each of them and the first registration wins, so a second spelling
// could only add noise to the console. The step kinds ARE declared, because
// they are this page's own closed vocabulary (BUILD-BRIEF-R3f §1).
import { registerDe } from '../i18n/index.js';

registerDe({
  'Run': 'Lauf',
  'Agents': 'Agenten',
  'no run was addressed': 'kein Lauf wurde adressiert',
  'This address names no run': 'Diese Adresse benennt keinen Lauf',
  'A run desk is opened as #run?id=N from a RUN- ref — on the Agents panel, on an organisation’s brief, or beside a proposal in Review.':
    'Ein Laufplatz wird als #run?id=N über eine RUN--Referenz geöffnet — auf der Agentenseite, auf dem Blatt einer Organisation oder neben einem Vorschlag in der Prüfung.',
  'reading the run…': 'Lauf wird gelesen…',
  'the runtime did not answer': 'die Laufzeit hat nicht geantwortet',
  'Could not read this run': 'Dieser Lauf konnte nicht gelesen werden',

  // ── the masthead ──
  'started': 'gestartet',
  'queued': 'in Warteschlange',
  'ended': 'beendet',
  'Open in Review': 'In der Prüfung öffnen',
  'Abort': 'Abbrechen',

  // ── the rail ──
  'Status': 'Status',
  'failed‖run': 'fehlgeschlagen',
  'done': 'erledigt',
  'aborted': 'abgebrochen',
  'behind {n}': '{n} davor',
  '{live} of {cap} running': '{live} von {cap} laufen',
  'night cap': 'Nachtgrenze',
  'weekend cap': 'Wochenend-Limite',
  'the gate has not reported a position': 'die Schranke hat keinen Platz gemeldet',
  'started {when}': 'gestartet {when}',
  'not started yet': 'noch nicht gestartet',
  'Tokens': 'Tokens',
  'in / out': 'ein / aus',
  'nothing has been spent yet': 'es wurde noch nichts ausgegeben',
  'the run reported no token count': 'der Lauf hat keine Tokenzahl gemeldet',
  '{n} failed': '{n} fehlgeschlagen',
  'the total arrives when the run ends · the steps count as they go': 'die Gesamtsumme kommt am Ende des Laufs · die Schritte zählen unterwegs',
  'Tool calls': 'Werkzeugaufrufe',
  '{n} refused': '{n} abgelehnt',
  'it has called nothing': 'er hat nichts aufgerufen',
  'every call was answered': 'jeder Aufruf wurde beantwortet',
  'Proposals filed': 'Eingereichte Vorschläge',
  'it has proposed nothing': 'er hat nichts vorgeschlagen',
  'Cells': 'Zellen',
  'this skill fills no raster cell': 'diese Fertigkeit füllt keine Rasterzelle',
  'raster cells filed as proposals · held in Review': 'als Vorschläge eingereichte Rasterzellen · übernommen in der Prüfung',
  'it filed no cell': 'er hat keine Zelle eingereicht',
  'cells arrive as it reads': 'die Zellen treffen ein, während er liest',

  // ── the steps zone ──
  'Steps': 'Schritte',
  'appended live · every three seconds': 'live angehängt · alle drei Sekunden',
  '{n} of {total} recorded': '{n} von {total} erfasst',
  'the account this run left of itself': 'die Rechenschaft, die dieser Lauf über sich abgelegt hat',
  'Follow': 'Mitlaufen',
  'Keep the newest step in view as it arrives': 'Den neuesten Schritt im Blick behalten, sobald er eintrifft',
  'The steps did not load: {error}': 'Die Schritte konnten nicht geladen werden: {error}',
  'This server has recorded no steps for this run — the steps route did not answer. What the run called is still below in the ledger, and what it filed is still in Review.':
    'Dieser Server hat für diesen Lauf keine Schritte erfasst — die Schrittroute hat nicht geantwortet. Was der Lauf aufgerufen hat, steht weiter unten im Journal, und was er eingereicht hat, steht in der Prüfung.',
  'No step yet. The loop writes one as it queues, starts, plans, reads a page, calls the model and proposes or drops a cell; they arrive here without a reload.':
    'Noch kein Schritt. Die Schleife schreibt einen beim Einreihen, Starten, Planen, beim Lesen einer Seite, beim Modellaufruf und bei jeder vorgeschlagenen oder verworfenen Zelle; sie treffen hier ohne Neuladen ein.',
  'This run recorded no step. It ran before the steps table existed, or it ended before it wrote one.':
    'Dieser Lauf hat keinen Schritt erfasst. Er lief, bevor es die Schritttabelle gab, oder er endete, bevor er einen schrieb.',
  'detail': 'Detail',
  'What this step recorded, as it recorded it': 'Was dieser Schritt erfasst hat, so wie er es erfasst hat',

  // the closed set of step kinds — this page's own vocabulary, declared in full
  'plan': 'Plan',
  'hide': 'ausblenden',
  'search': 'Suche',
  'fetch': 'Abruf',
  'read': 'Lesung',
  'model': 'Modell',
  'propose': 'Vorschlag',
  'drop': 'Verworfen',
  'waiting': 'wartet',
  'finish': 'Abschluss',
  'truncated': 'Abgeschnitten',

  // ── the proposals, the ledger, the report ──
  'Proposals': 'Vorschläge',
  'nothing is on the record until an operator holds it':
    'nichts steht im Bestand, bis eine Operatorin es übernimmt',
  'Review': 'Prüfung',
  'This run has filed nothing. A run proposes: a fact with its quote, a person with the line that names them, a draft. Each one waits in Review for a click.':
    'Dieser Lauf hat nichts eingereicht. Ein Lauf schlägt vor: einen Fakt mit seinem Zitat, eine Person mit der Zeile, die sie nennt, einen Entwurf. Jeder wartet in der Prüfung auf einen Klick.',
  'Ledger': 'Journal',
  'every call this run made · refusals included': 'jeder Aufruf dieses Laufs · Ablehnungen inbegriffen',
  'This run called no tool. Only an agent that goes through the registry writes ledger rows.':
    'Dieser Lauf hat kein Werkzeug aufgerufen. Nur ein Agent, der über die Registratur geht, schreibt Journalzeilen.',
  'no input recorded': 'keine Eingabe erfasst',
  'answered': 'beantwortet',
  'error': 'Fehler',
  'Report': 'Bericht',
  'the agent’s final answer, as it wrote it': 'die abschliessende Antwort des Agenten, so wie er sie geschrieben hat',
  'the agent writes one when it ends': 'der Agent schreibt einen, wenn er endet',
  'The child’s own output, while it runs. Not a report, and not a claim.':
    'Die eigene Ausgabe des Kindprozesses, während er läuft. Kein Bericht und keine Behauptung.',
  'No report yet. The agent answers when it has finished; its steps above say what it is doing meanwhile.':
    'Noch kein Bericht. Der Agent antwortet, wenn er fertig ist; seine Schritte oben sagen, was er inzwischen tut.',
  'This run left no report. It ended before the agent answered; its steps and its ledger are the account.':
    'Dieser Lauf hat keinen Bericht hinterlassen. Er endete, bevor der Agent antwortete; seine Schritte und sein Journal sind die Rechenschaft.',

  // ── the modal ──
  'Stop {ref}?': '{ref} anhalten?',
  '{ref} was asked to stop. It stops at its next step boundary.':
    '{ref} wurde zum Anhalten aufgefordert. Er hält an seiner nächsten Schrittgrenze an.',
  'Could not stop this run.': 'Dieser Lauf konnte nicht angehalten werden.',
  'It stops at its next step boundary. Everything it has already filed stays in Review, and everything it has already spent stays on the record — a stopped run is a shorter run, not an undone one.':
    'Er hält an seiner nächsten Schrittgrenze an. Alles, was er bereits eingereicht hat, bleibt in der Prüfung, und alles, was er bereits ausgegeben hat, bleibt erfasst — ein angehaltener Lauf ist ein kürzerer Lauf, kein rückgängig gemachter.',
  'signal_action': 'Signalaktion',
  'rule_change': 'Regeländerung',
}, 'RunPage');
